import { SNAP_TOKEN_NAME } from '../constants';
import config from '../config';
import { getCurrentDeviceAgent } from '../utilities/DeviceAgentHelper';
import memoryStorage from '../storage/memoryStorage';
import request, { post as genericPost } from './';

const MAX_RETRIES = 3;
const AUTH_ENDPOINT = '/snap-auth/um/token';

const getSnapToken = async () => {
  const domainId = config.REACT_APP_SNAP_DOMAIN_ID;

  const tokenResponse = await genericPost(AUTH_ENDPOINT, {
    baseUrl: config.REACT_APP_SNAP_BASE_URL,
    headers: { ...HeaderDefault(), domainId },
    params: {},
  });
  return tokenResponse.body.token;
};

const HeaderDefault = () => {
  const { userAgent, dId } = getCurrentDeviceAgent();
  const deviceAgentHeader = {
    'User-Agent': userAgent,
    dId,
  };
  const token = memoryStorage.getItem(SNAP_TOKEN_NAME);
  return {
    'Content-Type': 'application/json',
    ...deviceAgentHeader,
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

const createSnapRequest = method => async (
  url,
  params,
  customHeaders = {},
  snapRequestOption = {},
  totalRetries = 0
) => {
  const currentToken = memoryStorage.getItem(SNAP_TOKEN_NAME);
  const { baseUrl } = snapRequestOption;
  if (!currentToken) {
    const token = await getSnapToken();
    memoryStorage.setItem(SNAP_TOKEN_NAME, token);
  }

  const result = await request[method](url, {
    params,
    baseUrl: baseUrl || config.REACT_APP_SNAP_BASE_URL,
    headers: { ...HeaderDefault(), ...customHeaders },
  });
  if (result.status === 401 && totalRetries < MAX_RETRIES) {
    const token = await getSnapToken();
    memoryStorage.setItem(SNAP_TOKEN_NAME, token);

    return createSnapRequest(method)(
      url,
      params,
      customHeaders,
      snapRequestOption,
      totalRetries + 1
    );
  } else {
    return result;
  }
};

const get = createSnapRequest('get');
const put = createSnapRequest('put');
const post = createSnapRequest('post');

export { get, put, post };
